import { render, staticRenderFns } from "./StandaloneArticle.vue?vue&type=template&id=656a9223"
import script from "./StandaloneArticle.vue?vue&type=script&lang=js"
export * from "./StandaloneArticle.vue?vue&type=script&lang=js"
import style0 from "./StandaloneArticle.vue?vue&type=style&index=0&id=656a9223&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports